import { formatDate } from '@vy/date';
import { notDefined } from '@vy/null';
import { formatNumber as formatLocalisedNumber } from '@vy/number';

export function formatReportDate(date: Date): string {
  return formatDate(date, 'DD.MM.YYYY');
}

export function formatMonthHeader(date: Date): string {
  return formatDate(date, 'MMM YYYY');
}

export function formatResetCycle(resetIntervalMonths: number | null | undefined): string {
  if (notDefined(resetIntervalMonths)) {
    return 'Never';
  }
  if (resetIntervalMonths === 1) {
    return 'Monthly';
  }
  if (resetIntervalMonths === 2) {
    return 'Bi Monthly';
  }
  if (resetIntervalMonths === 3) {
    return 'Quarterly';
  }
  if (resetIntervalMonths === 6) {
    return 'Bi Yearly';
  }
  if (resetIntervalMonths === 12) {
    return 'Annually';
  }
  return `Every ${resetIntervalMonths} months`;
}

export function formatPercent(value: number | null | undefined): string {
  if (notDefined(value) || !Number.isFinite(value)) {
    return '';
  }
  return `${formatLocalisedNumber(value * 100, 2)}%`;
}

export function formatNumber(value: number | null | undefined): string {
  if (notDefined(value)) {
    return '';
  }
  return formatLocalisedNumber(value, 2);
}

export function formatContractEnd(endDate: Date | null | undefined): string {
  if (notDefined(endDate)) {
    return 'EverGreen';
  }
  return formatReportDate(endDate);
}

export function formatResetCell(isResetMonth: boolean | null | undefined): string {
  if (notDefined(isResetMonth)) {
    return '';
  }
  return isResetMonth ? 'Yes' : '—';
}
